import React, { useContext, useEffect } from "react"
import { ContextDispatch } from "./../../context/Context"

//Components
import Profile from "../../components/profile/profile"
import Footer from "../../components/footer/footer"
import NextPage from "../../components/next-page/next-page"
import SEO from "../../components/seo/seo"

// import pageTemplateQuery from "./pageQuery"

const ProfileTemplate = props => {
  const page = props,
    templateData = page.data.contentfulProfileTemplate

  const storeDispatch = useContext(ContextDispatch)

  useEffect(() => {
    const header = () => {
      storeDispatch({ type: "HEADER_LIGHT" })
    }

    header()
  }, [storeDispatch])

  return (
    <React.Fragment>
      <SEO
        title={templateData.seoData?.seoTitle}
        image={templateData.seoData?.seoImage}
        description={templateData.seoData?.seoDescription}
      />
      <Profile
        name={templateData.name}
        title={templateData.titleAndCompany}
        bio={templateData.bio}
        image={templateData.profileImage}
      />
      <NextPage
        heading={`Ready To Talk?`}
        title={`Get In Touch`}
        url={``}
        contact={true}
      />

      <Footer />
    </React.Fragment>
  )
}

export default ProfileTemplate

export const pageQuery = graphql`
  query ProfilePageBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulProfileTemplate(slug: { eq: $slug }) {
      ...profileQuery
    }
  }
`
